// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorUsage } from './elevator-usage';


export class ElevatorUsageMessage implements flatbuffers.IUnpackableObject<ElevatorUsageMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorUsageMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorUsageMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorUsageMessage):ElevatorUsageMessage {
  return (obj || new ElevatorUsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorUsageMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorUsageMessage):ElevatorUsageMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorUsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ElevatorUsage {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ElevatorUsage.Up;
}

static startElevatorUsageMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:ElevatorUsage) {
  builder.addFieldInt16(0, message, ElevatorUsage.Up);
}

static endElevatorUsageMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createElevatorUsageMessage(builder:flatbuffers.Builder, message:ElevatorUsage):flatbuffers.Offset {
  ElevatorUsageMessage.startElevatorUsageMessage(builder);
  ElevatorUsageMessage.addMessage(builder, message);
  return ElevatorUsageMessage.endElevatorUsageMessage(builder);
}

unpack(): ElevatorUsageMessageT {
  return new ElevatorUsageMessageT(
    this.message()
  );
}


unpackTo(_o: ElevatorUsageMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): ElevatorUsageMessageT {
  const t = new ElevatorUsageMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class ElevatorUsageMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ElevatorUsage = ElevatorUsage.Up
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ElevatorUsageMessage.createElevatorUsageMessage(builder,
    this.message
  );
}

clone(): ElevatorUsageMessageT {
  const obj = new ElevatorUsageMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: ElevatorUsageMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyElevatorUsageMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
